import { useAppContext } from "../AppProviders";
import { API_URL } from "./helpers";
import { useMutation } from "react-query";

export function useCancel360() {
  const { requestApi } = useAppContext();
  const cancel360 = async (productReportUUIDs: string[]): Promise<void> => {
    return requestApi
      .post(`${API_URL}/360/cancel`, { request_uuids: productReportUUIDs })
      .then((response) => {
        return response.data;
      });
  };
  const mutationResult = useMutation(
    (productReportUUIDs: string[]) => cancel360(productReportUUIDs),
    {}
  );
  return { ...mutationResult };
}

export function useCancelMisconduct() {
  const { requestApi } = useAppContext();
  const cancelMisconduct = async (
    productReportUUIDs: string[]
  ): Promise<void> => {
    return requestApi
      .post(`${API_URL}/misconduct/cancel`, {
        request_uuids: productReportUUIDs,
      })
      .then((response) => {
        return response.data;
      });
  };
  const mutationResult = useMutation(
    (productReportUUIDs: string[]) => cancelMisconduct(productReportUUIDs),
    {}
  );
  return { ...mutationResult };
}
